const getNotification = () => document.getElementById('refresh-notification');
const refreshNotification = {
  show: (onRefresh: () => void) => {
    const notification = getNotification();
    if (!notification) return;

    // Show the notification
    notification.classList.add('visible');

    // Set up refresh button
    const refreshButton = notification.querySelector('.refresh');
    if (refreshButton) {
      refreshButton.addEventListener('click', () => {
        onRefresh();
        setTimeout(() => window.location.reload(), 250);
      });
    }

    // Set up close button
    const closeButton = notification.querySelector('.close');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        notification.classList.remove('visible');
      });
    }
  },

  hide: () => {
    const notification = getNotification();
    if (notification) {
      notification.classList.remove('visible');
    }
  },
};

export default refreshNotification;
